import { render } from "./ClientAddTask.vue?vue&type=template&id=5c1c0ae6"
import script from "./ClientAddTask.vue?vue&type=script&lang=js"
export * from "./ClientAddTask.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__